import { Box, Paper, Typography } from "@mui/material";
import WorkflowCreateInternalReports from "./WorkflowCreateInternalReports";

export function InternalReports() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        paddingTop: "1rem",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          maxWidth: "800px",
          justifyContent: "center",
          gap: "1rem",
        }}
      >
        <Typography variant="h5">Interna Rapporter</Typography>

        <WorkflowCreateInternalReports />
      </div>
    </Box>
  );
}
